import React from 'react'

const Hero = () => {
  return (
    <>
      <div className='MainHero'>
        <div className='HeroText'>
            <h2>Bettter digital experience with Ninestars</h2>
            <h5>We are team of talented designers making websites with Bootstrap</h5>
            <a href="https://www.linkedin.com/in/shaon07/" target="_blank"><button>Get Started</button></a>
        </div>
        <div className='HeroImage'>
            <img className='image-fluid' src="https://bootstrapmade.com/demo/templates/Ninestars/assets/img/hero-img.svg" alt="heroimage" />
        </div>
      </div>
    </>
  )
}

export default Hero
